<template>
  <div class="setup-content contact-info" id="step-3">
    <div class="form-row justify-content-between">
      <div class="d-flex">
        <h3 class="color-darkblue mr-4">{{ labor_spelling }}</h3>
        <a v-on:click="showSRTModal()"
          class="mt-1 a-srt-manual">SRT Manual</a>
      </div>
      <div v-if="viewAllfields" class="verified-checkbox mr-4">
        <div class="form-group row claim-verified-checkbox pt-7">
          <label for="labor_section_verified" class="control-label claim-mr-2">Verified:</label>
          <input type="checkbox" v-model="section_verified" :disabled="disableAllFields" name="labor_section_verified" id="labor_section_verified" />
        </div>
      </div>
    </div>
    <div class="table-responsive-sm mt-2">
      <table class="table table-bordered table-sm" style="table-layout: fixed;">
        <thead>
          <tr class="table-primary">
            <th scope="col" style="width: 4%;" class="text-left">{{ labor_spelling }} Line #</th>
            <th scope="col" style="width: 12%;" class="text-left">SRT Code</th>
            <th scope="col" style="width: 20%;" class="text-left">SRT Description</th>
            <th scope="col" class="text-left">SRT Hours</th>
            <th scope="col" class="text-left">Requested Hours</th>
            <th scope="col" class="text-left">Dealer {{labor_spelling}} Rate</th>
            <th scope="col" class="text-left">{{labor_spelling}} Line Price</th>
            <!-- the fields below should be visible only to the admin users -->
            <th scope="col" class="text-left">Approved Time</th>
            <th scope="col" class="text-left">Approved {{labor_spelling}}</th>
            <th scope="col"> Action</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(row, index) in rows" :key="index">
            <td>{{ index + 1 }}</td>
            <td>
              <v-select class="close-remove" v-model="row.srt" :disabled="claimStatus == 'In Process' || disableAll || disableAllFields" id="srt" name="srt"
                @search="onSearchSrt" @input="handleSrtChange(index)" placeholder="Search SRT" label="text"
                :options="srtArr" @change="srtChanged($event, index)">
              </v-select>
              <div class="field-error ml-0">{{ row.srt_error_msg }}</div>
            </td>
            <td>
              <div class="row">
                <div class="col-12">
                  <input type="text" placeholder="SRT Description" v-model="row.srt_description"
                    style="width:100% !important" :id="'srt_description' + index" :name="'srt_description' + index"
                    class="vgt-input" disabled>
                </div>
                <div class="col-12" v-if="row.is_srt_99">
                  Comment
                </div>
                <div class="col-12" v-if="row.is_srt_99">
                  <input type="text" placeholder="Comment" v-model="row.comment" style="width:100% !important"
                    :id="'comment' + index" :name="'comment' + index" class="vgt-input" :disabled="disableAll || disableAllFields">
                  <div class="field-error ml-0">{{ row.comment_error_msg }}</div>
                </div>
              </div>
            </td>
            <td>
              <input type="number" disabled placeholder="SRT Hours" v-model="row.srt_hours" :id="'srt_hours' + index"
                style="width:99% !important" :name="'srt_hours' + index" class="vgt-input text-right">
            </td>
            <td>
              <input type="number" placeholder="Requested Hours" v-model="row.requested_hours"
                :id="'requested_hours' + index" style="width:99% !important" :name="'requested_hours' + index"
                class="vgt-input text-right" :disabled="(!row.is_srt_99) || (dealerFieldsDisabled) || disableAllFields"
                v-on:keyup="calculateLaborClaimedAmount(index)" @keypress="filterNumericValue">
              <div class="field-error ml-0">{{ row.requested_hours_error_msg }}</div>
            </td>
            <td>
              <input type="text" :placeholder=" labor_spelling + ' Rate'" v-model="row.labor_rate" id="labor_rate_processed"
                name="labor_rate_processed" style="width:99% !important" class="vgt-input text-right"
                v-on:keyup="calculateLaborClaimedAmount(index)" @keypress="filterNumericValue" disabled>
              <div class="field-error ml-0">{{ row.labor_rate_error_msg }}</div>
            </td>
            <td>
              <input type="text" :placeholder=" labor_spelling + ' Line Price'" v-model="row.labor_line_price" id="labor_line_price"
                name="labor_line_price" style="width:99% !important" class="vgt-input text-right" disabled>
            </td>
            <!-- the fields below should be visible only to the admin users -->
            <td>
              <input type="number" placeholder="Approved Time" v-model="row.approved_time" :id="'approved_time' + index"
                style="width:99% !important" :name="'approved_time' + index" class="vgt-input text-right"
                :disabled="!viewAllfields || disableAllFields" v-on:keyup="calculateLaborClaimedAmount(index)"
                @keypress="filterNumericValue">
              <div class="field-error ml-0">{{ row.approved_time_error_msg }}</div>
            </td>

            <td>
              <input type="text" :placeholder="'Approved ' + labor_spelling" v-model="row.approved_labor_price"
                :id="'approved_labor_price' + index" style="width:99% !important" :name="'approved_labor_price' + index"
                class="vgt-input text-right" :disabled="true" v-on:keyup="calculateLaborClaimedAmount(index)">
              <div class="field-error ml-0">{{ row.approved_labor_price_error_msg }}</div>
            </td>
            <td class="text-center valign-middle">
              <template v-if="userObj.id == row.created_by">
                <a :class="{ 'custom-disabled-link': disableAllFields }" href="javascript:void(0);" title="Remove Item"  v-on:click="removeItem(index);"> <i
                    class="fp-delete"></i> </a>
              </template>
              <template v-else>
                <span class="close-row"> _ </span>
              </template>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="btn-groups mb-4">
      <template>
        <button type="submit" v-on:click.prevent="addRow()" class="btn btn-primary" :disabled="disableAll || disableAllFields || claimStatus == 'In Process'">
          <i class="fp-add"></i> Add {{ labor_spelling }} Item
        </button>
      </template>

    </div>

    <!-- The summary section starts -->
    <div class="order-summary mt-4">
      <div class="row">
        <div class="col-md-12">
          <div class="bg-white radius-5 p-3">
            <h3 class="color-darkblue"> {{ labor_spelling }} Totals </h3>
            <table class="table table-sm table-bordered">
              <thead>
                <tr class="table-primary">
                  <th class="text-center">Section Summary</th>
                  <th class="text-center">Total Requested Hours</th>
                  <th class="text-center">Total Requested</th>
                  <th class="text-center">Total Approved Hours</th>
                  <th class="text-center">Total Approved</th>
                  <th class="text-center">Total Adjusted</th>
                </tr>
              </thead>
              <tbody>
                <tr class="table-secondary">
                  <td></td>
                  <td class="text-center">{{ parseFloat(totalRequestedHours).toFixed(2) }}</td>
                  <td class="text-center">$ {{ amountFormat(totalRequestedAmount) }}</td>
                  <td class="text-center">{{ totalApprovedHours }}</td>
                  <td class="text-center">$ {{ amountFormat(totalApprovedAmount) }}</td>
                  <td class="text-center">$ {{ formatNegativeValueWithParentheses(totalAdjustedAmount, 2, 'total') }}
                  </td>
                </tr>
              </tbody>

            </table>
          </div>
        </div>
      </div>
    </div>
    <!-- The summary section ends -->
    <template>
      <div class="alert alert-warning hide w-50">
        <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span
            aria-hidden="true">&times;</span></button>
        <strong class="errormsg"></strong>
      </div>
    </template>

     <!-- SRT Manual modal -->
    <div class="modal fade" id="srtListModal" tabindex="-1" role="dialog" aria-labelledby="srtListLabel" aria-hidden="true">
      <div class="modal-dialog modal-xl" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="srtListLabel">SRT Manual</h5>
            <button type="button" class="close" v-on:click="hideSRTModal()" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body p-0" v-if="showSrtList">
            <srt-list :listOnly='true' />
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" v-on:click="hideSRTModal()">Close</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";

import { commonMixins } from '../../mixins/commonMixins';
import LoadingContent from "@/components/LoadingContent.vue";
import SrtList from '@/components/SrtList.vue';

Vue.component("loading-content", LoadingContent);
Vue.component("srt-list", SrtList);

export default {
  name: "EvLaborsTab",
  mixins: [commonMixins],
  props: {
    viewAllfields: {
      type: Boolean,
      default: false
    },
    dealerFieldsDisabled: {
      type: Boolean,
      default: true
    },
    disableAllFields: {
      type: Boolean,
      default: false
    },
    claimStatus: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    rows: [],
    laborTypeArr: ['ADMIN', 'ADVANCED DIAGNOSTIC', 'DIAGNOSTIC', 'GENERIC', 'STANDARD', 'STANDARD DIAGNOSTIC'],
    disableAll: false,
    laborTotalTable: [],
    claimedHours: 0,
    processedHours: 0,
    laborTotalAmount: 0,
    laborProcessedAmount: 0,
    laborNetClaimedAmount: 0,
    laborNetProcessedAmount: 0,
    dealerNetProcessedAmount: 0,
    srtArr: [],
    laborRate: '',
    section_verified: false,
    totalRequestedHours: 0,
    totalRequestedAmount: 0,
    totalApprovedHours: 0,
    totalApprovedAmount: 0,
    totalAdjustedAmount: 0,
    laborDetailId: '',
    rowsToDelete: [],
    userObj: JSON.parse(localStorage.getItem("user_obj")),
    initialLaborData: '',
    currentLaborData: '',
    showSrtList: false,
  }),
  mounted() {
    var self = this;
    var path = window.location.pathname;
    var segments = path.split("/");
    if (!segments[3]) {
      self.rows.push({
        id: "",
        srt: "",
        srt_description: "",
        srt_hours: '',
        requested_hours: '',
        labor_rate: '',
        labor_line_price: '',
        approved_time: '',
        adjusted_time: '',
        adjusted_amount: '',
        approved_labor_price: '',
        comment: "",
        is_srt_99: false,
        srt_error_msg: "",
        comment_error_msg: "",
        requested_hours_error_msg: "",
        labor_rate_error_msg: "",
        approved_time_error_msg: "",
        approved_labor_price_error_msg: "",
        approval_time_change: false,
        created_by: self.userObj.id
      });
    }
    const srtModal = document.getElementById('srtListModal');
    $(srtModal).on('hidden.bs.modal', () => {
      // Handle modal close here
      this.showSrtList = false;
    });
  },
  methods: {
    srtChanged(value, index){
      if(
        (value == '' || value == null)
        &&
        this.rows[index] != undefined)
      {
        this.rows[index].srt = '';
      }
    },
    showSRTModal(){
      this.showSrtList = true;
      $("#srtListModal").modal('show');
    },
    hideSRTModal(){
      this.showSrtList = false;
      $("#srtListModal").modal('hide');
    },
    gotoNext: function (flag) {
      var self = this;
      // var success = self.validateAllRowsForSend();
      // if (success) {
      self.emitDataToParent();
      self.gotoNextStepMixins(flag);
      // }
    },
    gotoBack: function (flag) {
      var self = this;
      self.gotoBackStepMixins(flag);
    },
    addRow() {
      var self = this;
      var success = true;
      for (var i = 0; i < self.rows.length; i++) {
        success = self.validateSelectedRow(i);
      }
      if (success) {
        self.rows.push({
          id: "",
          srt: "",
          srt_description: "",
          srt_hours: '',
          requested_hours: '',
          labor_rate: '',
          labor_line_price: '',
          approved_time: '',
          adjusted_time: '',
          adjusted_amount: '',
          approved_labor_price: '',
          comment: "",
          is_srt_99: false,
          srt_error_msg: "",
          comment_error_msg: "",
          requested_hours_error_msg: "",
          labor_rate_error_msg: "",
          approved_time_error_msg: "",
          approved_labor_price_error_msg: "",
          created_by: self.userObj.id
        });
      }
    },
    removeItem(index) {
      var self = this;
      if (self.rows.length > 1) {
        if (self.rows[index].id != "") {
          self.rowsToDelete.push({
            id: self.rows[index].id
          });
        }
        self.rows.splice(index, 1);
      }

      self.calculateTotals();
    },
    clearRowErrorMessages(index) {
      var self = this;

      self.rows[index].srt_error_msg = "";
      self.rows[index].comment_error_msg = "";
      self.rows[index].requested_hours_error_msg = "";
      self.rows[index].labor_rate_error_msg = "";
      self.rows[index].approved_time_error_msg = "";
      self.rows[index].approved_labor_price_error_msg = "";
    },
    validateSelectedRow(index) {
      var self = this;
      var success = true;
      if (self.rows.length > 0) {
        self.clearRowErrorMessages(index);
        success = this.checkDuplicateSRT(index);
        if (self.rows[index].srt == null || self.rows[index].srt == "") {
          self.rows[index].srt_error_msg = "SRT Required";
          success = false;
        }
        if (self.rows[index].is_srt_99) {
          if (self.rows[index].comment == null || self.rows[index].comment == '') {
            self.rows[index].comment_error_msg = "Comment Required";
            success = false;
          }
          if (self.rows[index].requested_hours == null || self.rows[index].requested_hours == '') {
            self.rows[index].requested_hours_error_msg = "Requested Hours Required";
            success = false;
          }
        }
        if (self.rows[index].labor_rate == null || self.rows[index].labor_rate == '') {
          self.rows[index].labor_rate_error_msg = self.labor_spelling+" Price Required";
          success = false;
        }
        if (self.viewAllfields && self.rows[index].srt_hours != 0) {
          if (self.rows[index].approved_time == null || self.rows[index].approved_time == '') {
            self.rows[index].approved_time_error_msg = "Approved Time Required";
            success = false;
          }
          if (self.rows[index].approved_labor_price == null || self.rows[index].approved_labor_price == '') {
            self.rows[index].approved_labor_price_error_msg = "Approved " + self.labor_spelling + " Price Required";
            success = false;
          }
        }
      }
      return success;
    },
    validateAllRowsForSend() {
      var self = this;
      var success = true;
      for (var i = 0; i < self.rows.length; i++) {
        success = self.validateSelectedRow(i);
      }
      return success;
    },
    calculateLaborClaimed(index) {
      var self = this;
      var rowClaimed = parseFloat(self.rows[index].claimed);
      if (typeof (rowClaimed) === 'number' && rowClaimed > 0) {
        self.rows[index].labor_claimed = 0;
        self.rows[index].labor_claimed = rowClaimed;
        self.calculateTotalLaborClaimed();
      } else {
        self.rows[index].labor_claimed = 0;
        self.calculateTotalLaborClaimed();
      }
    },
    calculateTotalLaborClaimed() {
      var self = this;
      self.laborTotalAmount = 0;
      for (var i = 0; i < self.rows.length; i++) {
        var rowClaimed = parseFloat(self.rows[i].claimed);
        if (typeof (rowClaimed) === 'number' && rowClaimed > 0) {
          self.laborTotalAmount = self.laborTotalAmount + rowClaimed;
        }
      }
      self.calculateTotalLaborNetAmount();
    },
    calcualteTotalLaborHours(index) {
      var self = this;
      self.claimedHours = 0;
      // todo need to change caclulation logic?
      for (var i = 0; i < self.rows.length; i++) {
        var rowHour = parseFloat(self.rows[i].hours);
        if (typeof (rowHour) === 'number' && rowHour > 0) {
          self.claimedHours = self.claimedHours + rowHour;
        }
      }
      self.calculateTotalLaborNetAmount();
      // self.populateProcessedField(index);
    },
    calculateTotalLaborNetAmount() {
      var self = this;
      self.laborNetClaimedAmount = self.laborTotalAmount * self.claimedHours;
    },
    calculateLaborTotals(index) {
      var self = this;
      self.calculateTotalLaborClaimed();
      self.calcualteTotalLaborHours(index);
    },
    populateProcessedField(index) {
      var self = this;
      if (parseInt(self.rows[index].srt_hours) > parseInt(self.rows[index].hours)) {
        self.rows[index].processed = self.rows[index].hours;
      } else {
        self.rows[index].processed = self.rows[index].srt_hours;
      }
      self.calculateLaborProcessed(index);
      self.calculateLaborClaimedNew(index);
    },
    calculateLaborProcessed(index) {
      var self = this;
      self.rows[index].labor_processed = parseFloat(self.rows[index].processed) * parseFloat(self.rows[index].labor_rate_processed);
    },
    calculateLaborClaimedNew(index) {
      var self = this;
      self.rows[index].labor_claimed = parseFloat(self.rows[index].hours) * parseFloat(self.rows[index].labor_rate_processed);
    },
    emitDataToParent() {
      var self = this;
      self.beforeDataEmitToParent();
      const dataToSend = {
        rows: self.rows, // todo need to clear out the unnecessary fields in the rows.
        verified: self.section_verified,
        totalRequestedHours: self.totalRequestedHours,
        totalRequestedAmount: parseFloat(self.totalRequestedAmount).toFixed(2),
        totalApprovedHours: self.totalApprovedHours,
        totalApprovedAmount: parseFloat(self.totalApprovedAmount).toFixed(2),
        totalAdjustedAmount: parseFloat(self.totalAdjustedAmount).toFixed(2),
        laborDetailId: self.laborDetailId,
        rowsToDelete: self.rowsToDelete
      };
      self.$emit("send-labor-data-to-parent", dataToSend);
    },
    beforeDataEmitToParent() {
      var self = this;
      self.rows.forEach((row) => {
        if (row.labor_rate) {
          row.labor_rate = self.customFunctionForAmountFormat(row.labor_rate);
          row.labor_rate = parseFloat(row.labor_rate).toFixed(2);
        }
        if (row.approved_labor_price) {
          row.approved_labor_price = self.customFunctionForAmountFormat(row.approved_labor_price);
          row.approved_labor_price = parseFloat(row.approved_labor_price).toFixed(2);
        }
        if (row.labor_line_price) {
          row.labor_line_price = self.customFunctionForAmountFormat(row.labor_line_price);
          row.labor_line_price = parseFloat(row.labor_line_price).toFixed(2);
        }
        if (row.approved_time == '') {
          row.approved_time = 0;
        }
        if (row.adjusted_time == '') {
          row.adjusted_time = 0;
        }
        if (row.approved_labor_price == '') {
          row.approved_labor_price = '0.00';
        }
        if (row.adjusted_amount == '') {
          row.adjusted_amount = '0.00';
        } else {
          row.adjusted_amount = self.amountFormat(row.adjusted_amount);
        }
        if (row.labor_line_price == '') {
          row.labor_line_price = '0.00';
        }
      });
    },
    validationFail() {
      var self = this;
      self.rows.forEach((row) => {
        if (row.labor_rate) {
          row.labor_rate = self.formatCurrency(row.labor_rate);
        }
        if (row.labor_line_price) {
          row.labor_line_price = self.formatCurrency(row.labor_line_price);
        }
        row.approved_labor_price = self.customFunctionForAmountFormat(row.approved_labor_price);

        if (row.approved_labor_price !== '') {
          row.approved_labor_price = self.formatCurrency(row.approved_labor_price);
        }
        if (row.approved_time === 0 || row.approved_time === '') {
          row.approved_time = '';
        }
        if (row.adjusted_amount === 0 || row.adjusted_amount === '') {
          row.adjusted_amount = '';
        }
      });
    },
    getLaborLineItems(lineItemData) {
      var self = this;
      if (lineItemData.length > 0) {
        self.rows = [];
        for (var i = 0; i < lineItemData.length; i++) {
          self.rows.push(lineItemData[i]);
        }
      }
    },
    getLaborTotals(totalData) {
      var self = this;
      self.claimedHours = totalData.labor_claimed_hours;
      self.processedHours = totalData.labor_processed_hours;
      self.laborTotalAmount = totalData.labor_total_amount;
      self.laborProcessedAmount = totalData.labor_processed_amount;
      self.laborNetClaimedAmount = totalData.labor_net_claimed_amount;
      self.laborNetProcessedAmount = totalData.labor_net_processed_amount;
      self.dealerNetProcessedAmount = totalData.dealer_net_processed_amount;
    },
    onSearchSrt(search, loading) {
      var self = this;
      if (search.length > 1) {

        loading(true);
        self.searchField(loading, search, 'labor_srt', '');
      }
    },
    handleSrtChange(index) {
      if (this.rows[index].srt) {
        this.rows[index].srt_error_msg = "";
        if (this.checkDuplicateSRT(index)) {
          this.rows[index].approval_time_change = false;
          this.clearFields(index);
          this.populateSrtFields(index);
        }
      } else {
        this.clearFields(index);
      }
    },
    checkDuplicateSRT(index) {
      var noDuplicates = true;
      for (let i = 0; i < this.rows.length; i++) {
        if (i != index) {
          if (this.rows[i].srt.value == this.rows[index].srt.value) {
            noDuplicates = false;
            this.rows[index].srt_error_msg = "Duplicate SRT cannot be selected";
          }
        }
      }
      return noDuplicates;
    },
    clearFields(index) {
      this.rows[index].srt_hours = '';
      this.rows[index].requested_hours = '';
      this.rows[index].labor_rate = '';
      this.rows[index].approved_time = '';
      this.rows[index].adjusted_time = '';
      this.rows[index].labor_line_price = '';
      this.rows[index].approved_labor_price = '';
      this.rows[index].srt_error_msg = "";
      this.rows[index].comment = "";
      this.rows[index].is_srt_99 = false;
    },
    populateSrtFields(index) {
      var self = this;
      self.rows[index].srt_hours = self.rows[index].srt.hours;
      self.rows[index].srt_description = self.rows[index].srt.falcon_code;
      self.rows[index].labor_rate = self.laborRate;

      self.checkForSpecialSrtCode(index);
      self.calculateLaborClaimedAmount(index);
    },
    calculateLaborClaimedAmount(index, flag = false) {
      this.calculateTotals(flag);
    },
    startProcessButtonClicked(flag) {
      this.clearTotalAmounts(false);
      for (const row of this.rows) {
        if (flag) {
          row.labor_rate = this.customFunctionForAmountFormat(row.labor_rate);
          row.labor_line_price = this.customFunctionForAmountFormat(row.labor_line_price);
        }

        if (
          row.approved_time != '' &&
          !isNaN(row.labor_rate) &&
          row.labor_rate != '' &&
          row.labor_rate != '0.00'
        ) {
          row.approved_labor_price = (row.approved_time * parseFloat(row.labor_rate));
        } else {
          row.approved_labor_price = '';
        }

        if (row.approved_time) {
          row.adjusted_time = '';
          const timeAdjusted = row.approved_time - row.requested_hours;
          row.adjusted_time = timeAdjusted;

          row.adjusted_amount = 0.00;
          if (
            !isNaN(row.labor_rate) &&
            row.labor_rate != '' &&
            row.approved_labor_price != ''
          ) {
            let amountAdjusted;
            if (row.requested_hours) {
              amountAdjusted = row.approved_labor_price - (parseFloat(row.labor_rate) * row.requested_hours);
            } else {
              amountAdjusted = row.approved_labor_price - parseFloat(row.labor_rate);
            }
            row.adjusted_amount = amountAdjusted;
          }
        }
        if (row.approved_labor_price) {
          this.totalApprovedAmount += parseFloat(row.approved_labor_price);
        }
        if (row.approved_time !== '') {
          this.totalApprovedHours = parseFloat((this.totalApprovedHours + parseFloat(row.approved_time)).toFixed(2));
        }
        if (row.adjusted_amount != '') {
          this.totalAdjustedAmount += parseFloat(row.adjusted_amount);
        }
        // // adding a $ sign
        if (row.approved_labor_price) {
          row.approved_labor_price = this.formatCurrency(parseFloat(row.approved_labor_price).toFixed(2));
        }
        if (row.labor_rate) {
          row.labor_rate = this.formatCurrency(row.labor_rate);
        }
        if (row.labor_line_price) {
          row.labor_line_price = this.formatCurrency(row.labor_line_price);
        }
      }
      this.emitTotalAmountToParent();
    },
    calculateTotals() {
      this.clearTotalAmounts(true);
      for (const row of this.rows) {
        if (row.requested_hours != '') {
          row.requested_hours = this.customFunctionForAmountFormat(row.requested_hours);
          this.totalRequestedHours += parseFloat(row.requested_hours);
        } else {
          row.labor_line_price = '';
        }

        if (row.labor_rate) {
          row.labor_rate = this.customFunctionForAmountFormat(row.labor_rate);
          if (row.requested_hours) {
            this.totalRequestedAmount += row.labor_rate * row.requested_hours;
          }
        }

        if (row.labor_line_price) {
          row.labor_line_price = this.customFunctionForAmountFormat(row.labor_line_price);
        }
        if (row.requested_hours && row.labor_rate) {
          row.labor_line_price = (row.requested_hours * row.labor_rate);
        }
      }
      this.startProcessButtonClicked(false);
    },
    clearTotalAmounts(flag) {
      if (flag) {
        this.totalRequestedHours = 0;
        this.totalRequestedAmount = 0;
      }
      this.totalApprovedHours = 0;
      this.totalApprovedAmount = 0;
      this.totalAdjustedAmount = 0;
    },
    emitTotalAmountToParent() {
      if (typeof this.totalRequestedAmount == 'string') {
        this.totalRequestedAmount = parseFloat(this.totalRequestedAmount);
      }
      if (typeof this.totalApprovedAmount == 'string') {
        this.totalApprovedAmount = parseFloat(this.totalApprovedAmount);
      }
      if (typeof this.totalAdjustedAmount == 'string') {
        this.totalAdjustedAmount = parseFloat(this.totalAdjustedAmount);
      }

      this.totalRequestedAmount = this.totalRequestedAmount;
      this.totalApprovedAmount = this.totalApprovedAmount;
      this.totalAdjustedAmount = this.totalAdjustedAmount;
      // sending calculation data to parent
      const calculationData = {
        totalRequestedAmount: this.totalRequestedAmount,
        totalApprovedAmount: this.totalApprovedAmount,
        totalAdjustedAmount: this.totalAdjustedAmount,
      };
      this.$emit("send-calculation-labor-data-to-parent", calculationData);
    },
    laborAttachmentUpload(index, event) {
      this.rows[index].attachment = event.target.files[0];
      this.rows[index].attachmentError = "";
    },
    checkForSpecialSrtCode(index) {
      var code = this.rows[index].srt.operation_code;
      if (code.includes("99")) {
        this.rows[index].is_srt_99 = true;
      } else {
        this.rows[index].is_srt_99 = false;
        this.rows[index].requested_hours = this.rows[index].srt_hours;
      }
    },
    getDataFromParent(laborData) {
      this.populateLaborLineItems(laborData.ev_labor_line_items);
      this.section_verified = (laborData.verified == 0) ? false : true;
      this.totalRequestedHours = laborData.total_requested_hours;
      this.totalRequestedAmount = laborData.total_requested_amount;
      this.totalApprovedHours = laborData.total_approved_hours;
      this.totalApprovedAmount = laborData.total_approved_amount;
      this.totalAdjustedAmount = laborData.total_adjusted_amount;
      this.laborDetailId = laborData.id;

      this.$nextTick(() => {
        this.populateInitialLaborData(true);
      });
    },
    populateInitialLaborData(flag) {
      if(flag) {
        setTimeout(() => {
          this.setInitialValue(flag);
        }, 500);
      } else {
        return this.setInitialValue(flag);
      }
    },
    setInitialValue(flag){
      var rows = this.rows.map(row => {
        let updatedRow = { ...row };
        Object.keys(updatedRow).forEach(key => {
          if (typeof updatedRow[key] === "string" && updatedRow[key].includes("$")) {
            updatedRow[key] = parseFloat(updatedRow[key].replace(/[^0-9.-]+/g, "")).toFixed(2);
          }

          // Handle specific fields with default values
          if (["labor_line_price", "approved_labor_price", "adjusted_amount"].includes(key)) {
            updatedRow[key] = updatedRow[key] === "" ? "0.00" : updatedRow[key];
          }

          if (["approved_time", "adjusted_time"].includes(key)) {
            updatedRow[key] = updatedRow[key] === "" ? 0 : updatedRow[key];
          }

          // Ensure adjusted_amount has two decimals if needed
          if (key === "adjusted_amount" && !isNaN(updatedRow[key])) {
            if (updatedRow[key] === 0 || updatedRow[key] % 1 !== 0) {
              updatedRow[key] = parseFloat(updatedRow[key]).toFixed(2);
            }
            updatedRow[key] = updatedRow[key].toString();
          }
        });
        return updatedRow;
      });

      const laborData = JSON.stringify({
        rows: rows,
        verified: this.section_verified,
        totalRequestedHours: this.totalRequestedHours,
        totalRequestedAmount: parseFloat(this.totalRequestedAmount).toFixed(2),
        totalApprovedHours: this.totalApprovedHours,
        totalApprovedAmount: parseFloat(this.totalApprovedAmount).toFixed(2),
        totalAdjustedAmount: parseFloat(this.totalAdjustedAmount).toFixed(2),
        laborDetailId: this.laborDetailId,
        rowsToDelete: this.rowsToDelete
      });

      if (flag) {
        this.initialLaborData = '';
        this.initialLaborData = laborData;
      } else {
        this.currentLaborData = '';
        this.currentLaborData = laborData;

        return this.initialLaborData !== this.currentLaborData;
      }
    },
    populateLaborLineItems(laborLineItems) {
      for (let i = 0; i < laborLineItems.length; i++) {
        const item = laborLineItems[i];

        if(item.ev_labor_srt != null){
          var srt = {value: item.ev_labor_srt.id, text: item.ev_labor_srt.operation_code};
          var srt_description = item.ev_labor_srt.falcon_code;
          var srt_hours = item.ev_labor_srt.hours;
        }else{
          var srt = "";
          var srt_description = "";
          var srt_hours = "";
        }
        this.rows.push({
          id: item.id,
          srt: srt,
          srt_description: srt_description,
          srt_hours: srt_hours,
          requested_hours: item.requested_hours,
          labor_rate: item.labor_price,
          labor_line_price: item.labor_line_price == '0.00' ? '' : item.labor_line_price,
          approved_time: item.approved_time == 0 ? '' : item.approved_time,
          adjusted_time: item.adjusted_time == 0 ? '' : item.adjusted_time,
          adjusted_amount: item.adjusted_amount == '0.00' ? '' : item.adjusted_amount,
          approved_labor_price: item.approved_labor_amount == '0.00' ? '' : item.approved_labor_amount,
          comment: item.comment,
          is_srt_99: !!item.comment,
          srt_error_msg: "",
          comment_error_msg: "",
          requested_hours_error_msg: "",
          labor_rate_error_msg: "",
          approved_time_error_msg: "",
          approved_labor_price_error_msg: "",
          approval_time_change: item.requested_hours !== item.adjusted_time,
          created_by: item.created_by === null ? this.userObj.id : item.created_by
        });
      }
      this.calculateTotals();
    },
    clearAllFields(rePopulate = false) {
      var self = this;
      self.section_verified = false;

      self.rows = [];
      if (!rePopulate) {
        self.rows.push({
          srt: "",
          srt_description: "",
          srt_hours: '',
          requested_hours: '',
          labor_rate: '',
          labor_line_price: '',
          approved_time: '',
          adjusted_time: '',
          adjusted_amount: '',
          approved_labor_price: '',
          comment: "",
          is_srt_99: false,
          srt_error_msg: "",
          comment_error_msg: "",
          requested_hours_error_msg: "",
          labor_rate_error_msg: "",
          approved_time_error_msg: "",
          approved_labor_price_error_msg: "",
          created_by: self.userObj.id
        });
      }
      self.totalRequestedHours = 0;
      self.totalRequestedAmount = 0;
      self.totalApprovedHours = 0;
      self.totalApprovedAmount = 0;
      self.rowsToDelete = [];
    },
    populateLaborRate(laborRate) {
      this.laborRate = "$" + laborRate;
      this.laborRateChanged();
    },
    laborRateChanged() {
      for (const row of this.rows) {
        if (row.srt) {
          row.labor_rate = this.laborRate;
        }
      }
      this.calculateTotals();
    }
  },
}
</script>
<style scoped>
.a-srt-manual{
  cursor: pointer;
  font-size: 16px;
  color: blue;
}
</style>



// WEBPACK FOOTER //
// src/components/warrantyClaimTabs/EvLaborsTab.vue